import { Injectable } from '@angular/core';

import { EasyDebugDecorator } from '../../app/decorators/easy-debug.decorator';
import { StatsService } from './stats.service';

import * as Sentry from '@sentry/angular';

@Injectable({
  providedIn: 'root',
})
@EasyDebugDecorator
export class SentryService {
  // ########################################################
  // # SENTRYSERVICE IS USED TO SEND CUSTOM ERROR TO SENTRY #
  // ########################################################

  constructor(private statsService: StatsService) {}

  async sendToSentry(error, studentData = null) {
    console.error('SentryService : ' + error);
    let context = { id: 'guest' };

    const student = studentData;
    const statsContext = !!student ? (student.status !== 'guest' ? await this.statsService.processUser() : null) : null;
    context = {
      id: !!student ? student.remoteId : 'guest',
      ...statsContext,
    };

    Sentry.withScope(function (scope: any) {
      scope.setUser(context);
      Sentry.captureException(error.originalError || error);
    });
  }
}
